<template>
  <v-row v-if="exibirBanner" class="mb-4">
    <v-col cols="12" class="px-4">
      <v-card 
        flat 
        color="transparent"
        class="rounded-xl overflow-hidden transition-swing" 
        style="cursor: pointer;" 
        hover
        @click="tratarCliqueBanner"
      >
        <v-img 
          :src="imagemBanner" 
          width="100%"
          @error="erroNaImagem = true"
          @load="erroNaImagem = false"
        >
          <template v-slot:placeholder>
            <v-skeleton-loader
              type="image"
              height="100%"
              width="100%"
            ></v-skeleton-loader>
          </template>

          <v-row 
            v-if="erroNaImagem" 
            class="fill-height ma-0 grey lighten-4" 
            align="center" 
            justify="center"
          >
            <div class="text-center pa-4">
              <v-icon color="grey" size="40">mdi-image-broken-variant</v-icon>
              <div class="grey--text mt-2 font-weight-bold">Erro ao carregar a imagem</div>
            </div>
          </v-row>
        </v-img>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';

export default {
  name: 'BannerCupons',
  data: () => ({
    campanha: null,
    erroNaImagem: false, 
  }),
  computed: {
    // 1. Verifica se existe alguma imagem de ganhadores no JSON (Web ou Mobile)
    isGanhadoresImageActive() {
      return this.campanha && !!(this.campanha.img_ganhadores_web || this.campanha.img_ganhadores_mobile);
    },

    imagemBanner() {
      if (!this.campanha) return "";

      const isMobile = this.$vuetify.breakpoint.smAndDown;

      // 2. Tenta montar a imagem dos Ganhadores (respeitando o dispositivo)
      const imgGanhadores = isMobile
        ? (this.campanha.img_ganhadores_mobile || this.campanha.img_ganhadores_web)
        : (this.campanha.img_ganhadores_web || this.campanha.img_ganhadores_mobile);

      // 3. Tenta montar a imagem da Campanha (respeitando o dispositivo)
      const imgCampanha = isMobile
        ? (this.campanha.img_campanha_mobile || this.campanha.img_campanha_web)
        : (this.campanha.img_campanha_web || this.campanha.img_campanha_mobile);

      // Prioridade absoluta: Ganhadores > Campanha > Vazio
      return imgGanhadores || imgCampanha || "";
    },

    exibirBanner() {
      return this.campanha && this.campanha.exibir && this.imagemBanner !== "";
    }
  },
  methods: {
    async buscarCampanha() {
      try {
        const res = await axios.get('/colaborador/cupons');
        if (res.data.success) {
          this.campanha = res.data.data;
        }
      } catch (error) {
        console.error("Erro ao buscar banner de cupons:", error);
      }
    },
    tratarCliqueBanner() {
      if (this.isGanhadoresImageActive) {
        this.$router.push('/ganhadores-dia-trabalhador');
      } else {
        this.$router.push('/cupons'); 
      }
    }
  },
  mounted() {
    this.buscarCampanha();
  }
}
</script>